export default function PHP_pow() {
  return (
    <div>
      <h1>PHP_pow</h1>
    </div>
  );
}
